import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../../store';

export const selectAuthState = (state: RootState) => state.auth;

export const selectLoggedIn = createSelector(selectAuthState, (state) => state.loggedIn);

export const selectCustomer = createSelector(selectAuthState, (state) => state.customer.value!);
export const selectCustomerLoading = createSelector(
  selectAuthState,
  (state) => state.customer.loading
);
export const selectCustomerLoaded = createSelector(
  selectAuthState,
  (state) => state.customer.loaded
);
export const selectCustomerInitialized = createSelector(
  selectAuthState,
  (state) => state.customer.loaded
);

export const selectAuthInitiator = createSelector(
  selectAuthState,
  (state) => state.authInitiator.value
);

export const selectLoginButton = createSelector(
  selectAuthState,
  (state) => state.loginButton.value
);
export const selectLoginSection = createSelector(
  selectAuthState,
  (state) => state.loginSection.value
);
export const selectLogoutButton = createSelector(
  selectAuthState,
  (state) => state.logoutButton.value
);
export const selectLogoutSection = createSelector(
  selectAuthState,
  (state) => state.logoutSection.value
);
export const selectWaitingSection = createSelector(
  selectAuthState,
  (state) => state.waitingSection.value
);

export const selectAuthenticationLoading = createSelector(
  selectAuthState,
  (state) => state.authentication.loading
);
export const selectAuthenticationLoaded = createSelector(
  selectAuthState,
  (state) => state.authentication.loaded
);
export const selectAuthentication = createSelector(
  selectAuthState,
  (state) => state.authentication.value
);
export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state) => state.authentication.value?.authenticated ?? false
);

export const selectAccountTypeLoading = createSelector(
  selectAuthState,
  (state) => state.accountType.loading
);
export const selectAccountTypeLoaded = createSelector(
  selectAuthState,
  (state) => state.accountType.loaded
);
export const selectAccountType = createSelector(
  selectAuthState,
  (state) => state.accountType.value
);
export const selectIsLegacyAccount = createSelector(
  selectAccountType,
  (accountType) => accountType === 'LEGACY'
);
export const selectIsNewAccount = createSelector(
  selectAccountType,
  (accountType) => accountType === 'NEW'
);

export const selectAuthenticationResult = createSelector(
  selectAuthState,
  (state) => state.authenticationResult
);

export const selectAccountSettings = createSelector(
  selectAuthState,
  (state) => state.accountSettingsResponse.value!
);
export const selectAccountSettingsLoading = createSelector(
  selectAuthState,
  (state) => state.accountSettingsResponse.loading
);
export const selectAccountSettingsLoaded = createSelector(
  selectAuthState,
  (state) => state.accountSettingsResponse.loaded
);
